export const Drawers = {
	init: function()
	{
		this.drawerButton = $('.open-drawer');
		this.drawer = $('.floorplans .drawer');

		this.bindEvents();
		this.drawer.slideUp();
	},

	bindEvents: function()
	{
		this.drawerButton.on('click', this.handleDrawer);
	},

	handleDrawer: function()
	{
		if(!$(this).prev().is(":visible"))
	    {
	    	$(this).find('.instructions').text('Hide');
	    	$(this).prev().slideDown();
	    }
	    else
	    {
	    	$(this).find('.instructions').text('Show');
	    	$(this).prev().slideUp();
	    }
	}
};